import React from "react";
import { formatDateWithTime } from "../../../utilities/dateUtils";

export default function SalesPlayCard({
  title = "Nestlé Packaging Strategy",
  time = "",
  onClickArtifact = () => {},
}) {
  return (
    <div
      style={{
        width: "100%",
        padding: "1rem 1.2rem",
        borderRadius: "14px",
        background: "#f4f6fb",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        boxSizing: "border-box",
        gap: "1rem",
      }}
    >
      {/* LEFT SECTION */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minWidth: 0, // IMPORTANT to allow ellipsis
        }}
      >
        <div
          style={{
            fontSize: "0.95rem",
            fontWeight: 500,
            color: "#111827",
            whiteSpace: "nowrap", // FORCE SINGLE LINE
            overflow: "hidden",
            textOverflow: "ellipsis", // SHOW "..."
            width: "100%",
          }}
        >
          {title}
        </div>

        <div
          style={{
            marginTop: "4px",
            fontSize: "0.75rem",
            color: "#6b7280",
            whiteSpace: "nowrap",
          }}
        >
          {formatDateWithTime(time)}
        </div>
      </div>

      {/* OPEN BUTTON */}
      <button
        style={{
          background: "#4f1df0",
          color: "#fff",
          fontSize: "0.7rem",
          fontWeight: 500,
          padding: "0.35rem 1.2rem",
          border: "none",
          borderRadius: "18px",
          cursor: "pointer",
          flexShrink: 0, // PREVENT button from shrinking
        }}
        onClick={onClickArtifact}
      >
        Open
      </button>
    </div>
  );
}
